import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

const Authorized = ({ Component, roles, id }) => {
  const user = useSelector((state) => state.auth.user);

  return (
    <>
      {roles.includes(user.role_id) ? (
        <Component id={id} />
      ) : (
        <Navigate to='/admin/users' />
      )}
    </>
  );
};

export default Authorized;
